import dayjs from "dayjs"

export interface IItem { ID: string; Name: string }
export interface IPhysicalCount { ID: string; Name: string }

export interface IOrderRef { id: number; reference_number: number; _destroy?: boolean }
export interface IOrderMixEntry { id: number; item_id: string; item_name: string; item: IItem | null; percentage_value: number; total_value: number; mix_type: "primary" | "secondary"; _destroy?: boolean }
export interface IOrderPrintInk { id: number; color_name: string; side: "A" | "B"; _destroy?: boolean }

export interface IOrder {
    id: number
    // Sent by the server on every load; the edit form keys its reset on it so
    // that Save & Continue re-syncs the server-assigned nested ids.
    updated_at?: string | null
    order_code: string
    order_number: number
    order_date: string
    order_entry_date: string | null
    order_comment: string
    client_name: string
    project_name: string
    location: string
    city: string
    order_references: IOrderRef[]
    reference_name: string
    reference_width: number
    reference_height: number
    reference_grammage: number
    reference_sides: number
    reference_bellows: number
    reference_paper_color: number
    final_product_weight_per_roll: number
    final_product_weight_per_core: number
    general_info_requested_amount: number
    general_info_rolls_amount: number
    general_info_programmed_kilograms: number
    general_info_waste_percentage: number
    general_info_waste: number
    general_info_refile_percentage: number
    general_info_refile: number
    general_info_programmed_total: number
    general_info_thousand_weight_min: number
    general_info_thousand_weight_max: number
    extrusion_extruder_number: number
    extrusion_mold: number
    extrusion_width: number
    extrusion_width_formula: string
    extrusion_width_min: number
    extrusion_width_max: number
    extrusion_grammage: number
    extrusion_caliber: number
    extrusion_caliber_min: number
    extrusion_caliber_max: number
    extrusion_pigment: boolean
    extrusion_treatment: boolean
    extrusion_treatment_type: number
    extrusion_bellows: number
    order_mix_total_percentage: number
    order_mix_total_value: number
    order_mix_entries: IOrderMixEntry[]
    order_secondary_mix_total_percentage: number
    order_secondary_mix_total_value: number
    printer_number: number
    printing_width: number
    printing_height: number
    printing_inks_amount: number
    printing_roller: number
    printing_mounting: number
    printing_threaded: number
    printing_rolls_number: number
    printing_kg_per_roll: number
    printing_mt_per_roll: number
    order_print_inks: IOrderPrintInk[]
    sealing_width: number
    sealing_width_min: number
    sealing_width_max: number
    sealing_length: number
    sealing_length_min: number
    sealing_length_max: number
    sealing_side_seal: boolean
    sealing_seal_bottom: boolean
    sealing_seal_double_bottom: boolean
    sealing_cut_bottom: boolean
    sealing_packages_per_master_case_count: number
    sealing_amount_per_package: number
    sealing_amount_per_master_case: number
    sealing_master_case_count: number
    sealing_side_bellows: number
    sealing_bottom_bellows: number
    sealing_box_type: number
    status: string
    physical_count_id: string | null
    export?: { id: number; name: string } | null
}

export type FormProps = {
    is_edit: boolean
    order?: IOrder | null
    initial_order_code?: string | null
    initial_order_number?: number | null
    back_params: Record<string, string | null>
    errors?: Record<string, string[]>
}

export type SetValueFn = (name: string, value: unknown) => void

export function defaultOrder(orderCode: string, orderNumber: number): IOrder {
    return {
        id: 0, order_code: orderCode, order_number: orderNumber,
        order_date: dayjs().format("YYYY-MM-DD"), order_entry_date: null, order_comment: "",
        client_name: "", project_name: "", location: "", city: "Santiago de los Caballeros", status: "active",
        physical_count_id: null,
        order_references: [],
        reference_name: "", reference_width: 0, reference_height: 0, reference_grammage: 0,
        reference_sides: 0, reference_bellows: 0, reference_paper_color: 1,
        final_product_weight_per_roll: 40, final_product_weight_per_core: 1.5,
        general_info_requested_amount: 0, general_info_rolls_amount: 0,
        general_info_programmed_kilograms: 0, general_info_waste_percentage: 0,
        general_info_waste: 0, general_info_refile_percentage: 0, general_info_refile: 0,
        general_info_programmed_total: 0, general_info_thousand_weight_min: 0,
        general_info_thousand_weight_max: 0,
        extrusion_extruder_number: 0, extrusion_mold: 0, extrusion_width: 0,
        extrusion_width_formula: "", extrusion_width_min: 0, extrusion_width_max: 0,
        extrusion_grammage: 0, extrusion_caliber: 0, extrusion_caliber_min: 0,
        extrusion_caliber_max: 0, extrusion_pigment: false, extrusion_treatment: false,
        extrusion_treatment_type: 0, extrusion_bellows: 0,
        order_mix_total_percentage: 0, order_mix_total_value: 0, order_mix_entries: [],
        order_secondary_mix_total_percentage: 0, order_secondary_mix_total_value: 0,
        printer_number: 1, printing_width: 0, printing_height: 0, printing_inks_amount: 0,
        printing_roller: 0, printing_mounting: 0, printing_threaded: 0,
        printing_rolls_number: 0, printing_kg_per_roll: 0, printing_mt_per_roll: 0,
        order_print_inks: [],
        sealing_width: 0, sealing_width_min: 0, sealing_width_max: 0,
        sealing_length: 0, sealing_length_min: 0, sealing_length_max: 0,
        sealing_side_seal: false, sealing_seal_bottom: false, sealing_seal_double_bottom: false,
        sealing_cut_bottom: false, sealing_packages_per_master_case_count: 0,
        sealing_amount_per_package: 1000, sealing_amount_per_master_case: 0,
        sealing_master_case_count: 0, sealing_side_bellows: 0, sealing_bottom_bellows: 0,
        sealing_box_type: 0,
    }
}
